import { fetcherPatch, fetcherPost, unAuthedAxiosService } from '../util/axios';

export const login  = async (phoneNo:string, password:string) => {
  const result = await unAuthedAxiosService.post('member/auth/sign-in', { email: phoneNo, password });
  return result.data.data as Auth;
};

export const changeMemberPassword = async (fromPassword:string, toPassword:string, memberId:number) => fetcherPatch(`member/auth/reset-password/${memberId}`, { fromPassword, toPassword });
